module.exports = __webpack_public_path__ + "img/directory.23474e42.svg";